import { ServerCog } from 'lucide-react'
import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'

import { REPOSITORY_COPY } from '#app/routes/mocra+/_form+/components/repositories/constants.ts'
import {
	formatRepositorySummary,
	repositoryCardTitle,
	type RepositoryDraft,
} from '#app/routes/mocra+/_form+/components/repositories/types.ts'

type Props = {
	readonly repository: RepositoryDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly removeDisabled?: boolean
	readonly errors?: readonly string[]
}

export function RepositoryCard({
	repository,
	onEdit,
	onRemove,
	removeDisabled,
	errors,
}: Props) {
	const title = repositoryCardTitle(repository)
	const summary = formatRepositorySummary(repository)
	const hasErrors = Boolean(errors && errors.length > 0)
	const description = hasErrors ? `${summary} • Needs attention` : summary

	return (
		<EntityCard
			title={title}
			description={description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={removeDisabled}
			removeLabel="Remove"
			removeConfirmTitle={REPOSITORY_COPY.actions.removeRepositoryConfirmTitle}
			removeConfirmDescription={
				REPOSITORY_COPY.actions.removeRepositoryConfirmDescription
			}
			icon={
				<ServerCog
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
			removeAriaLabel="Remove repository"
		/>
	)
}
